import $ from 'jquery';
import {getMessageParent, getMessageClass} from '../common/json-response';

function createMessageElement(message, type) {
  const messageElement = document.createElement('div');

  if (type === 'error') {
    messageElement.classList.add('field_error_message');
  } else if (type === 'success') {
    messageElement.classList.add('field_success_message');
  }

  const classes = getMessageClass(message.messageType);
  classes.forEach((messageClass) => {
    messageElement.classList.add(messageClass);
  });

  let content = 'Возникла ошибка. Пожалуйста обратитесь в техподдержку.';

  if (message.content?.length) {
    content = message.content;
  }

  messageElement.innerHTML = content;

  return messageElement;
}

function initContestJudgeAdd() {
  const judgeEmailInput = document.querySelector('.check_judge_email');

  if (!judgeEmailInput) {
    return;
  }

  const contestHashId = judgeEmailInput.getAttribute('data-contest_hash_id');

  const typingInterval = 500;
  let timer;

  async function checkEmail() {
    if (!judgeEmailInput.value) {
      return;
    }

    const response = await fetch('/cabinet/contests/' + contestHashId + '/judges/check-exists?email=' + judgeEmailInput.value);
    const result = await response.json();

    const emailfieldWrapElement = document.querySelector('[data-message-parent-id="email"]');

    if (result.status === 'success') {
      result.messages?.forEach(function (message) {
        const messageParent = getMessageParent(message);

        if (!messageParent) {
          return;
        }

        const messageElement = createMessageElement(message);

        messageParent.innerHTML = '';
        messageParent.appendChild(messageElement);
      });

      return;
    }

    if (result.error_type === 'contest_not_paid') {
      const modalSelector = '#paid-settings-modal[data-event-source-id="add-judge-email"]';
      const paidSettingsModal = document.querySelector(modalSelector);

      if (!paidSettingsModal) {
        return;
      }

      const overlay = $('#overlay');
      overlay.addClass('cabinet-contest-modal');
      overlay.fadeIn();
      paidSettingsModal.classList.add('active');
    } else {
      result.messages?.forEach(function (message) {
        const messageParent = getMessageParent(message);

        if (!messageParent) {
          return;
        }

        const messageElement = createMessageElement(message);

        messageParent.innerHTML = '';
        messageParent.appendChild(messageElement);
      });
    }
  }

  judgeEmailInput.addEventListener('keydown', function (e) {
    clearTimeout(timer);
  });

  judgeEmailInput.addEventListener('keyup', async function (e) {
    clearTimeout(timer);
    timer = setTimeout(checkEmail, typingInterval);
  });
}

export { initContestJudgeAdd }